import React, { useRef, useEffect } from 'react'

import {
  Box,
  Link,
  Color,
  Heading2,
  AlignItems,
  JustifyContent,
  FontFamily,
  Display,
  TextAlign,
  useTheme,
  FlexDirection,
} from '@gousto-internal/citrus-react'

import { SeedBar } from './components/SeedBar'

type TrustPilotType = {
  loadFromElement: (element: HTMLElement | null, force: boolean) => void
}

type TrustpilotWindow = typeof window & {
  Trustpilot: TrustPilotType
}

export const TrustPilot = () => {
  const ref = useRef(null)
  const { theme } = useTheme()

  useEffect(() => {
    const win = window as TrustpilotWindow
    // widget may not load if the bootstrapper script has been loaded before the component gets rendered
    // we use the TrustPilot loadFromElement function to manually load the widget if this happens

    if (win.Trustpilot) {
      win.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [])

  return (
    <Box
      display={Display.Flex}
      flexDirection={[FlexDirection.Column, FlexDirection.Row]}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.SpaceBetween}
      bg={Color.NeutralGrey_50}
      data-testid="TrustPilot"
    >
      <SeedBar side="left" />
      <Box paddingV={10} paddingBottom={5} flexGrow={1} width={['100%', 'auto']} maxWidth="1171px">
        <Heading2 fontFamily={FontFamily.Bold} textAlign={TextAlign.Center}>
          Over{' '}
          <Heading2 display={Display.Inline} color={Color.Primary_600} fontFamily={FontFamily.Bold}>
            143 million meals{' '}
          </Heading2>
          cooked and loved
        </Heading2>
        <div
          ref={ref}
          className="trustpilot-widget"
          data-locale="en-GB"
          data-template-id="54ad5defc6454f065c28af8b"
          data-businessunit-id="512cda6e000064000522fb6a"
          data-style-height="240px"
          data-style-width="100%"
          data-theme="light"
          data-stars="4,5"
          data-review-languages="en"
          data-font-family="Montserrat"
          data-text-color={theme.color(Color.ColdGrey_800)}
          data-testid="TrustPilotWidget"
        >
          <Link href="https://uk.trustpilot.com/review/gousto.co.uk" target="_blank">
            Trustpilot
          </Link>
        </div>
      </Box>
      <SeedBar side="right" />
    </Box>
  )
}
